export const GET_ALL_FEEDBACK_SUCCESS = "GET_ALL_FEEDBACK_SUCCESS"
export const GET_ALL_FEEDBACK_LOADING = "GET_ALL_FEEDBACK_LOADING"
export const UPDATE_FEEDBACK_LOADING = "UPDATE_FEEDBACK_LOADING";
export const UPDATE_FEEDBACK_SUCCESS = "UPDATE_FEEDBACK_SUCCESS";
export const UPDATE_FEEDBACK_FAILED = "UPDATE_FEEDBACK_FAILED";
export const UPDATE_FEEDBACK_RESET = "UPDATE_FEEDBACK_RESET";